import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class KatiAtikTarifeListeAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "KatiAtikTarifeListe";
        super(baseUrl);
    }


    getKatiAtikTarifeListeListe(yili: number, binaKullanimTuruKodu: number, Grup?: number, Derece?: number) {
        return this.get("", { params: { yili: yili, binaKullanimTuruKodu: binaKullanimTuruKodu, Grup: Grup, Derece: Derece } })

    }

}

export default new KatiAtikTarifeListeAPI();